import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import axios from 'axios';
// import DataTable from '../../.../../components/table/Table';
import SearchBox from '../../../../components/table/SearchBox';
// import ReceiptIcon from '@material-ui/icons/Receipt';
import ActionTable from '../../common/Table';
// import Layout from '../../common/Layout';
import { CommonConfig } from '../../../../config/common-config';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    // title: {
    //     textAlign: 'left',
    //     paddingLeft: theme.spacing(1),
    //     color: '#1a1a1a',
    //     fontSize: '1.75rem'
    // }
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

const ImcInvoices = (props) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [datacontent, setRows] = useState([]);
    let rows = [];
    datacontent && datacontent.content && datacontent.content.length && datacontent.content.map((datadbname, i) => {
        if (datadbname.dbName !== 'itec') {
            rows.push(datadbname);
        }
    });
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };
    const [pageDetails, setPageDetails] = useState('');
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const headcells = [
        { id: 'intClientName', label: 'Name Of the entity' },
        {
            id: 'addressId',
            label: 'Address',
            isConcat: 'true',
            concatElem: ['addressLine1', 'addressLine2', 'city', 'stateId.stateName', 'pinCode', 'country'],
        },
        { id: 'gstIn', label: 'GSTIN' },
        { id: 'msmeNumber', label: 'MSME Regn No' },
        { id: 'panNumber', label: 'PAN' },
    ];

    // At the time of Component mounts
    const history = useHistory();
    useEffect(() => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        // axios.get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients?page=${page}&size=10&sort=id,desc`, axiosConfig).then((res) => {
        axios.get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, axiosConfig).then((res) => {

            setRows(res.data);
            setPageDetails(res.data);
            setLoading(false);
            if (res.data.first) {
                setpreviousButton(true);
                setnextButton(false);
            } else if (res.data.last) {
                setpreviousButton(false);
                setnextButton(true);
            } else {
                setpreviousButton(false);
                setnextButton(false);
            }
        });
    }, [userToken, page]);

    // handle search item
    const handleSearchQuery = (data) => {
        //console.log(data);
        setSearchQuery(data);
    };

    const clearField = () => {
        setSearchQuery('');
        // setSearchData([]);
        setPage(0);
    }

    // generate from Popup
    const handleGenerate = (row) => {
        //console.log("Back From Popup", JSON.stringify(row));
        history.push({
            pathname: '/menu/taxInvoice',
            row,
        });
    };
    const classes = useStyles();

    // filtered row based on search

    const filteredRow = searchQuery
        ? rows.filter((row) => {
            const query = searchQuery.toLowerCase().trim();
            //   ////console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
            return headcells
                .map((col) => col.id)
                .some((key) => {
                    //console.log(row[key],"Value of ROW****row[key]");
                    return row[key].toString().toLowerCase().includes(query);
                });
        })
        : rows;

    const back = () => {
        history.push({
            pathname: '/menu',
        });
    };

    return (
        <>
            <Card className="custom-table mb10">
                <CardContent className="card-title-display">
                    <Grid item xs={12} sm={8}>
                        <Typography className="card-title">Generate Invoice for IMC</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} className="card-search">
                        <div className="search-field">
                            <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                        </div>
                    </Grid>
                </CardContent>
                <CardContent className="card-table-display">
                    {rows && filteredRow.length > 0 ? (
                        <>
                            <ActionTable
                                headcells={headcells}
                                rows={filteredRow}
                                generate={handleGenerate}
                                post="superAdmin"
                                mode="generate"
                                action
                                pageDetails={pageDetails}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                loading={loading}
                                handleCount={handleCount} />
                        </>
                    ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}
                </CardContent>
            </Card>
            <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                Back
</Button>
        </>
    );
};

export default ImcInvoices;
